import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Label,
    Button
} from "reactstrap"
import { Preview } from '../../../../helpers/ui/FileInput'

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/seminarService'

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"

import IndexBloc from '../Index/Blocs/DataTableBloc'

import { Link, } from "react-router-dom"
import moment from 'moment'

class DetailView extends Component {
    source
    indexBloc = new IndexBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            domicile: 0,
            typeName: '-'
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.id
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }


    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        detail: result.data.response, 
                        domicile: result.data.response.seminar_domicile, 
                        typeName:result.data.response.seminar_type_name 
                    })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="seminar"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`?seminar`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Detail {this.state.typeName}</CardTitle>
                                    <hr />
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Jenis
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.seminar_type_name}
                                            </Label>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Nama {this.state.typeName} 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.seminar_name}
                                            </Label>
                                        </Row>
                                        <hr/>
                                        <Label># Tempat {this.state.typeName}</Label>
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Luar / Dalam Negeri
                                            </Label>
                                            <Label
                                                className="col-md-6 col-form-label"
                                            >
                                                {detail?.seminar_domicile ? 'Luar Negeri' : 'Dalam Negeri'}
                                            </Label>
                                        </Row>
                                        { this.state.domicile == 0 ?
                                            <Fragment>
                                                <Row className="mb-2">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Provinsi
                                                    </Label>
                                                    <Label
                                                        className="col-md-6 col-form-label"
                                                    >
                                                        {detail?.place?.seminar_province_name}
                                                    </Label>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota
                                                    </Label>
                                                    <Col md="3">
                                                    <Label
                                                        className="col-md-6 col-form-label"
                                                    >
                                                        {detail?.place?.seminar_city_name}
                                                    </Label>
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota
                                                    </Label>
                                                    <Col md="3">
                                                    <Label
                                                        className="col-md-6 col-form-label"
                                                    >
                                                        {detail?.place?.seminar_city_text}
                                                    </Label>
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        }
                                        <hr/>


                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Penyelanggara 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.seminar_organizer}
                                            </Label>
                                        </Row>


                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {this.dateParse(detail?.seminar_start_date)}
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {this.dateParse(detail?.seminar_end_date)}
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                No Piagam 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.seminar_charter_number}
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Piagam 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {this.dateParse(detail?.seminar_charter_date)}
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                File Piagam 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                <Preview
                                                    value={detail?.document}
                                                />
                                            </Label>
                                        </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }

}

export default DetailView
